import { apiFetch } from './client';
import type { Issue, IssueStatus, Paginated } from '$lib/types';

export type CareSection = 'open_issues' | 'need_to_speak' | 'reconnect' | 'contact_calls';
export interface CareIssue {
  order_number?: string | null;
  customer_name?: string | null;
  company_name?: string | null;
  resolving_technician_name?: string | null;
  id: number;
  vertical_id: number;
  title: string;
  status: IssueStatus;
  category: string;
  team_name: string;
  assignee_name: string | null;
  reporter_name: string;
  reporter_phone: string;
  reporter_email: string;
  location: string;
  next_action: string;
  next_action_date: string | null;
  resolved_at: string | null;
  last_customer_contact_at: string | null;
  customer_followup_at: string | null;
  last_team_update_at: string | null;
  customer_satisfaction: NonNullable<Issue['customer_satisfaction']>;
  stalled: boolean;
  overdue: boolean;
  reason: string;
}
export interface CareContact {
  next_action: string;
  next_action_date: string | null;
  id: number;
  vertical_id: number;
  first_name: string;
  last_name: string;
  relationship_type: string;
  phone: string;
  email: string;
  team_name: string;
  last_spoken_at: string | null;
  created_at: string;
  reason: string;
  days_since_spoken: number | null;
}
export interface CareResponse {
  generated_at: string;
  stalled_days: number;
  reconnect_days: number;
  teams: Array<{ id: number; name: string; slug: string }>;
  open_issues?: Paginated<CareIssue>;
  need_to_speak?: Paginated<CareIssue>;
  reconnect?: Paginated<CareContact>;
  contact_calls?: Paginated<CareContact>;
}
export interface CustomerCallInput {
  vertical_id: number;
  outcome: 'reached' | 'no_answer';
  body: string;
  customer_satisfaction: '' | 'pending' | 'satisfied' | 'not_satisfied';
  next_call_date: string | null;
}
export const customerCareApi = {
  list(section: CareSection, page: number, teamId: number | null, stalledDays: number, reconnectDays: number, options: { perPage?: number; businessOnly?: boolean } = {}) {
    const params = new URLSearchParams({ section, page: String(page), per_page: String(options.perPage ?? 10), stalled_days: String(stalledDays), reconnect_days: String(reconnectDays) });
    if (teamId !== null) params.set('team_id', String(teamId));
    if (options.businessOnly) params.set('contact_type', 'business');
    return apiFetch<CareResponse>(`/dashboard/customer-care?${params}`);
  },
  logCall(id: number, input: CustomerCallInput) {
    return apiFetch<Issue>(`/issues/${id}/customer-call`, { method: 'POST', body: JSON.stringify(input) });
  }
};
